import React, { Dispatch, SetStateAction } from 'react';

import { VehicleDetails } from 'Utilities/profiling/@types';

import type { ServiceFeeCalculateResponse, ServiceFeeTiersResponse } from '../../../../server/views/serviceFees/serviceFees.types';

import { VehicleImages } from './confirmSale/DataList/DataList.types';
import type { Document, State } from './DocumentCapture.helpers';
import { ConfirmSaleAllowedStatusesValue, DocumentCaptureReviewCompleteAllowedStatesValue, SaleConfirmedStatusesValue, viewTimelineStatusesValue } from './DocumentCapture.types';

export interface Valuation {
  buyerId?: number;
  createdAt?: Date;
  deepLink?: string;
  enquiryId?: number;
  // eslint-disable-next-line camelcase
  estimated_price?: number;
  id?: number;
  responseTime?: number;
  status?: string;
  updatedAt?: Date;
  valuation?: number;
  // eslint-disable-next-line camelcase
  valuation_ref?: string;
  // eslint-disable-next-line camelcase
  vehicle_ref?: null;
}

// TODO: improve typing
export type DocumentCaptureOfferContextType = {
  acceptedBid?: {
    dealer?: {
      companyPhone?: string;
      contactNumber?: string;
      contactPhone?: string;
      email?: string;
      name?: string;
      termsOfSale?: string;
    };
    dealerContact?: {
      dealer?: {
        id?: number;
        website?: string;
      };
    };
    id?: number;
    value?: number;
  };
  closingBid?: {
    dealer?: {
      id: number;
    };
    id?: number;
    value?: number;
  };
  data?: {
    // eslint-disable-next-line camelcase
    basic_details?: {
      additional_spec?: string;
      equipment?: string[];
      keepPrivatePlate?: boolean;
      mileage?: number;
      privatePlate?: boolean;
      seat_fabric?: string;
    };
    condition?: {
      [key: string]: string | boolean;
    };
    finance?:{
      isVehicleOnFinance?: boolean;
      settlementFigure?: number;
      settlementFigureOption?: number;
    };
    seller?: {
      Mobile: string;
      Name: string;
      PostCode: string;
      address1: string;
      address2: string;
      address3: string;
      keeperName: string | null;
      keeperType: VehicleDetails['keeperType'];
      town: string;
    };
    service_history?: {
      cambelt_change_date: string;
      cambelt_change_mileage: number;
      cambelt_changed: boolean;
      service_date: string;
      service_history: string;
      service_mileage: number;
      service_record: boolean;
      service_stamps_independent: number;
      service_stamps_official: number;
    };
    wheels_and_tyres?: {
        alloys?: boolean;
        alloys_details?: string;
        tool_pack?: boolean;
        tyres?: boolean;
        tyres_details?: string;
        wheelType?: string;
        wheel_nut?: boolean;
    };
  };
  enquiryId?: number;
  features?: {
    DOCUMENTS_PROGRESSIVE_UPLOAD?: boolean;
    SELLER_REENTRY?: boolean;
    documentCaptureV2?: boolean;
    paymentsMVP?: boolean;
    sellerBankStatement?: boolean;
  };
  id?: number;
  premiumOffer?: { id: undefined | number };
  serviceFee?: ServiceFeeCalculateResponse | null;
  serviceFeeTiers?: ServiceFeeTiersResponse | null;
  state?: {
    slug?:
    | ConfirmSaleAllowedStatusesValue
    | SaleConfirmedStatusesValue
    | viewTimelineStatusesValue
    | DocumentCaptureReviewCompleteAllowedStatesValue;
  };
  valuation?: Valuation;
  vehicleImages?: VehicleImages[];
} & State;

const documentCaptureOfferState: DocumentCaptureOfferContextType = {};

export const DocumentCaptureOfferContext = React.createContext(documentCaptureOfferState);
DocumentCaptureOfferContext.displayName = 'DocumentCaptureOfferContext';

// TODO: improve typing
export type DocumentCaptureConfirmationProgressContextType = {
  progress: {
    bankDetailsAdded?: boolean;
    bankDetailsReviewFailed?: boolean;
    confirmedBySeller?: boolean;
    documents?: Document[];
    documentsFulfilled?: boolean;
  };
  setProgress?: Dispatch<SetStateAction<DocumentCaptureConfirmationProgressContextType['progress']>>;
}

const documentCaptureConfirmationProgressState: DocumentCaptureConfirmationProgressContextType = {
  progress: {},
};

export const DocumentCaptureConfirmationProgressContext = React.createContext(documentCaptureConfirmationProgressState);

export type FinanceSettlementDetails = {
  documentLocation?: string;
  expiry?: string;
  figure?: string;
}

export type FinanceSettlementProviderContextType = {
  financeAgreement: {
    automatedFinanceProvider?: string;
    failedLookupReason?: string;
    optedOut?: boolean;
    settlementDetails?: FinanceSettlementDetails;
  };
  isAutomatedDocumentUpload?: boolean;
  setFinanceAgreement?: Dispatch<SetStateAction<FinanceSettlementProviderContextType['financeAgreement']>>;
  setIsAutomatedDocumentUpload?: Dispatch<SetStateAction<FinanceSettlementProviderContextType['isAutomatedDocumentUpload']>>;
}

const financeSettlementProviderState: FinanceSettlementProviderContextType = {
  financeAgreement: {},
  isAutomatedDocumentUpload: false,
};

export const FinanceSettlementProviderContext = React.createContext(financeSettlementProviderState);
